import React, { useState, useEffect } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { Button } from "antd";
import CloseIcon from "@mui/icons-material/Close";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import Swal from "sweetalert2";
import axios from "axios";
import {
  getDepartments,
  getCitiesByDepartment,
} from "../../../TMS-DynamicsV2/screen/services/get-departments-city";

const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const proxyBase = process.env.REACT_APP_FUNCTION_CONSUME_LOGS_GOOGLEMAPS;

const MapModalShipment = ({
  address,
  city,
  state,
  street,
  compliment,
  shippingId,
  onClose,
  setNewLocation,
}) => {
  const [departments, setDepartments] = useState([]);
  const [cities, setCities] = useState([]);
  const [departamento, setDepartamento] = useState(state || "");
  const [ciudad, setCiudad] = useState(city || "");
  const [direccion, setDireccion] = useState(street || "");
  const [complemento, setComplemento] = useState(compliment || "");
  const [latitud, setLatitud] = useState(4.570868);
  const [longitud, setLongitud] = useState(-74.297333);
  const [isEditing, setIsEditing] = useState(false);


  // 🔹 Carga inicial de departamentos
  useEffect(() => {
    const loadDeps = async () => {
      try {
        const data = await getDepartments();
        setDepartments(data);
      } catch (error) {
        console.error("Error cargando departamentos:", error);
      }
    };
    loadDeps();
  }, []);

  // 🔹 Cargar ciudades
  useEffect(() => {
    if (!departamento) {
      setCities([]);
      return;
    }
    const loadCities = async () => {
      try {
        const data = await getCitiesByDepartment(departamento);
        setCities(data);
      } catch (error) {
        console.error("Error cargando ciudades:", error);
      }
    };
    loadCities();
  }, [departamento]);

  // 🔹 Guardar cambios
  const handleSave = () => {
    const newLoc = {
      departamento,
      ciudad,
      direccion,
      complemento,
      latitud,
      longitud,
    };
    setNewLocation(newLoc);
    Swal.fire({
      icon: "success",
      title: "Ubicación actualizada",
      text: `El envío ${shippingId} se actualizó correctamente.`,
    });
  };

  // 🔹 Drag marker
  const handleMarkerDrag = (e) => {
    setLatitud(e.latLng.lat());
    setLongitud(e.latLng.lng());
  };

  const mapContainerStyle = {
    width: "100%",
    height: "280px", // ✅ altura equilibrada
    borderRadius: "12px",
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.4)", // 🔹 fondo oscuro
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          width: "95%",
          maxWidth: "1100px",
          background: "#fff",
          borderRadius: "15px",
          padding: "20px 25px",
          boxShadow: "0 8px 25px rgba(0,0,0,0.25)",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* 🔹 Botón X */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "15px",
            right: "20px",
            background: "transparent",
            border: "none",
            cursor: "pointer",
          }}
        >
          <CloseIcon style={{ fontSize: "24px", color: "#444" }} />
        </button>

        {/* 🔹 Título */}
        <h2
          style={{
            fontWeight: "700",
            color: "#333",
            margin: "0 0 5px 0",
          }}
        >
          Confirmar dirección de envío
        </h2>
        <p style={{ color: "#777", marginBottom: "15px" }}>
          Envío: {shippingId}
        </p>

        {/* 🔹 Mapa */}
        <LoadScript googleMapsApiKey={apiKey}>
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            center={{ lat: latitud, lng: longitud }}
            zoom={15}
          >
            <Marker
              position={{ lat: latitud, lng: longitud }}
              draggable={true}
              onDragEnd={handleMarkerDrag}
            />
          </GoogleMap>
        </LoadScript>

        {/* 🔹 Selects e inputs */}
        <div
          style={{
            marginTop: "15px",
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            justifyContent: "center",
          }}
        >
          <select
            value={departamento}
            onChange={(e) => setDepartamento(e.target.value)}
            style={{
              padding: "8px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              width: "200px",
            }}
          >
            <option value="">Seleccione un departamento</option>
            {departments.map((dep) => (
              <option key={dep.id} value={dep.id}>
                {dep.name}
              </option>
            ))}
          </select>

          <select
            value={ciudad}
            onChange={(e) => setCiudad(e.target.value)}
            disabled={!departamento}
            style={{
              padding: "8px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              width: "200px",
            }}
          >
            <option value="">Seleccione una ciudad</option>
            {cities.map((c, i) => (
              <option key={i} value={c}>
                {c}
              </option>
            ))}
          </select>

          <input
            type="text"
            value={direccion}
            onChange={(e) => setDireccion(e.target.value)}
            placeholder="Dirección"
            style={{
              padding: "8px",
              width: "330px",
              borderRadius: "6px",
              border: "1px solid #ccc",
            }}
          />

          <input
            type="text"
            value={latitud}
            readOnly
            style={{
              width: "110px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              padding: "8px",
            }}
          />
          <input
            type="text"
            value={longitud}
            readOnly
            style={{
              width: "110px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              padding: "8px",
            }}
          />

          <button
            onClick={handleSave}
            style={{
              background: "linear-gradient(to bottom, #FF5C5C, #C40000)",
              color: "#fff",
              border: "none",
              borderRadius: "10px",
              padding: "8px 12px",
              cursor: "pointer",
            }}
          >
            <SaveAsIcon />
          </button>
        </div>

        {/* 🔹 Complemento */}
        <input
          type="text"
          placeholder="Complemento"
          value={complemento}
          onChange={(e) => setComplemento(e.target.value)}
          style={{
            width: "95%",
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            marginTop: "10px",
          }}
        />

        {/* 🔹 Botones */}
        <div
          style={{
            marginTop: "18px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "25px",
          }}
        >
          {/* 🔹 Botones */}
          <div
            style={{
              marginTop: "18px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "25px",
            }}
          >
         {/* 🔹 Botones con modo edición */}
<div
  style={{
    marginTop: "18px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "25px",
  }}
>
  {/* Confirmar dirección */}
  <Button
    size="large"
    style={{
      background: "linear-gradient(to bottom, #0099FF, #0066CC)",
      color: "#fff",
      border: "none",
      borderRadius: "10px",
      fontWeight: "600",
      padding: "8px 30px",
    }}
    onClick={() => {
      Swal.fire({
        title: `¿Confirmar dirección del envío ${shippingId}?`,
        text: "Se actualizará la ubicación actual del envío.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, confirmar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          handleSave();
        }
      });
    }}
  >
    Confirmar dirección
  </Button>

  {/* Botón dinámico: Modificar o Cancelar edición */}
  {isEditing ? (
    <Button
      size="large"
      onClick={() => setIsEditing(false)}
      style={{
        background: "linear-gradient(to bottom, #FF5C5C, #C40000)",
        color: "#fff",
        border: "none",
        borderRadius: "10px",
        fontWeight: "600",
        padding: "8px 30px",
      }}
    >
      Cancelar edición
    </Button>
  ) : (
    <Button
      size="large"
      onClick={() => setIsEditing(true)}
      style={{
        background: "linear-gradient(to bottom, #FF5C5C, #C40000)",
        color: "#fff",
        border: "none",
        borderRadius: "10px",
        fontWeight: "600",
        padding: "8px 30px",
      }}
    >
      Modificar dirección
    </Button>
  )}
</div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default MapModalShipment;
